
import { Route, Routes as RouterRoutes } from "react-router-dom";
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import Index from "@/pages/Index";
import BagPage from "@/pages/BagPage";
import BrowseBags from "@/pages/BrowseBags";
import SearchResults from "@/pages/SearchResults";
import CatalogsPage from "@/pages/CatalogsPage";
import CatalogDetailPage from "@/pages/CatalogDetailPage";
import NotFound from "@/pages/NotFound";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

export function Routes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<Index />} />
      <Route path="/bag/:id" element={<BagPage />} />
      <Route path="/browse" element={<BrowseBags />} />
      <Route path="/search/:query" element={<SearchResults />} />
      <Route path="/catalogs" element={<CatalogsPage />} />
      <Route path="/catalogs/:id" element={<CatalogDetailPage />} />
      <Route path="/admin" element={<AdminLoginPage />} />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
}
